import React from 'react'

const TermsAndConditions = () => {
    return (
        <section className='px-4 sm:px-8 md:px-16 lg:px-24 xl:px-32 py-10'>
            <div className='max-w-7xl mx-auto'>
                <h1 className='text-headingColor text-2xl sm:text-3xl lg:text-3xl xl:text-4xl font-bold mb-10 text-center lg:text-left'>Terms and Conditions</h1>
                <div className='mb-8'>
                    <h2 className='text-headingColor text-xl sm:text-2xl lg:text-2xl xl:text-3xl font-semibold mb-4'>1. Introduction</h2>
                    <p className='text-textColor text-base sm:text-lg lg:text-lg xl:text-xl'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum.
                        Cras venenatis euismod malesuada.
                    </p>
                </div>
                <div className='mb-8'>
                    <h2 className='text-headingColor text-xl sm:text-2xl lg:text-2xl xl:text-3xl font-semibold mb-4'>2. User Responsibilities</h2>
                    <p className='text-textColor text-base sm:text-lg lg:text-lg xl:text-xl'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum.
                        Cras venenatis euismod malesuada.
                    </p>
                    <p className='text-textColor text-base sm:text-lg lg:text-lg xl:text-xl'>
                        Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Proin non dui at mi fermentum sagittis.
                        Ut dapibus dictum tortor, ac pretium odio.
                    </p>
                </div>
                <div className='mb-8'>
                    <h2 className='text-headingColor text-xl sm:text-2xl lg:text-2xl xl:text-3xl font-semibold mb-4'>3. Account Terms</h2>
                    <p className='text-textColor text-base sm:text-lg lg:text-lg xl:text-xl'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum.
                        Cras venenatis euismod malesuada.
                    </p>
                    <ul className='list-disc list-inside text-textColor text-base sm:text-lg lg:text-lg xl:text-xl'>
                        <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                        <li>Vivamus lacinia odio vitae vestibulum vestibulum.</li>
                        <li>Cras venenatis euismod malesuada.</li>
                    </ul>
                </div>
                <div className='mb-8'>
                    <h2 className='text-headingColor text-xl sm:text-2xl lg:text-2xl xl:text-3xl font-semibold mb-4'>4. Limitations of Liability</h2>
                    <p className='text-textColor text-base sm:text-lg lg:text-lg xl:text-xl'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum.
                        Cras venenatis euismod malesuada.
                    </p>
                </div>
                <div className='mb-8'>
                    <h2 className='text-headingColor text-xl sm:text-2xl lg:text-2xl xl:text-3xl font-semibold mb-4'>5. Changes to Terms</h2>
                    <p className='text-textColor text-base sm:text-lg lg:text-lg xl:text-xl'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum.
                        Cras venenatis euismod malesuada.
                    </p>
                    <p className='text-textColor text-base sm:text-lg lg:text-lg xl:text-xl'>
                        Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Proin non dui at mi fermentum sagittis.
                        Ut dapibus dictum tortor, ac pretium odio.
                    </p>
                </div>
                <div>
                    <h2 className='text-headingColor text-xl sm:text-2xl lg:text-2xl xl:text-3xl font-semibold mb-4'>6. Contact Information</h2>
                    <p className='text-textColor text-base sm:text-lg lg:text-lg xl:text-xl'>
                        If you have any questions about these Terms and Conditions, please contact us at:
                        <br />Email: support@example.com
                        <br />Phone: (123) 456-7890
                    </p>
                </div>
            </div>
        </section>
    )
}

export default TermsAndConditions